/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var NumbersIcon = createIcon("NumbersIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#32E034';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 36a1 1 0 110 2H9a1 1 0 110-2h30ZM20 22a2 2 0 012 2v8a2 2 0 11-4 0v-8a2 2 0 012-2Zm-8 8a2 2 0 110 4 2 2 0 010-4Zm16-20a2 2 0 012 2v20a2 2 0 11-4 0V12a2 2 0 012-2Zm8 6a2 2 0 012 2v14a2 2 0 11-4 0V18a2 2 0 012-2Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.NumbersIcon",
  "replaceColor": true
});